import { useState, useMemo } from 'react';
import { LineChart, TrendingUp } from 'lucide-react';
import DetailEleve from '../components/VueEleve/DetailEleve';
import EleveEvalNat from '../components/VueEleve/EleveEvalNat';

/**
 * Fiche élève à onglets (3.3) — réunit, pour UN élève, ses deux lentilles :
 *   - « Suivi continu »        → DetailEleve monté INTACT (acquis /6 en classe) ;
 *   - « Évaluations nationales »→ EleveEvalNat (niveaux du diagnostic national).
 *
 * Conteneur léger : rendu par Eleve.jsx à la place de DetailEleve quand un élève
 * est sélectionné (pas de route dédiée — on garde le toggle d'état existant).
 * DetailEleve reste une zone stable : on l'enveloppe, on ne le modifie pas
 * (il garde son propre bouton RETOUR vers la liste).
 */

const ONGLETS = [
    { key: 'suivi', label: 'Suivi continu', Icone: LineChart },
    { key: 'nationales', label: 'Évaluations nationales', Icone: TrendingUp },
];

function FicheEleve(props) {
    const { selectedEleveId, listEleves, handleRowClick } = props;
    const [onglet, setOnglet] = useState('suivi');

    const nomEleve = useMemo(() => {
        const e = (listEleves || []).find((x) => x.id === selectedEleveId);
        if (!e) return '';
        return e.eleve_gar ? `${e.eleve_gar_nom} ${e.eleve_gar_prenom}` : `${e.nom} ${e.prenom}`;
    }, [listEleves, selectedEleveId]);

    return (
        <div className="mt-3">
            {/* Onglets de la fiche */}
            <div className="px-4">
                <div className="inline-flex gap-1 p-1 rounded-xl bg-white border border-[#D5E6F3] shadow-sm">
                    {ONGLETS.map(({ key, label, Icone }) => (
                        <button
                            key={key}
                            onClick={() => setOnglet(key)}
                            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-bold transition-colors ${
                                onglet === key
                                    ? 'bg-blue-600 text-white shadow-sm'
                                    : 'text-slate-500 hover:bg-slate-50'
                            }`}
                        >
                            <Icone size={15} />
                            {label}
                        </button>
                    ))}
                </div>
            </div>

            <div className="mt-2">
                {onglet === 'suivi' ? (
                    // DetailEleve intact — reçoit tous ses props d'origine
                    <DetailEleve {...props} />
                ) : (
                    <EleveEvalNat
                        selectedEleveId={selectedEleveId}
                        nomEleve={nomEleve}
                        onBack={() => handleRowClick()}
                    />
                )}
            </div>
        </div>
    );
}

export default FicheEleve;
